/**
 * Static configuration for the QC Task page (MT-QC-TASK-001).
 * Keeps magic numbers and env fallbacks in one place for easier tuning.
 */

/** TanStack Query: workflows list stays fresh for 5 minutes when inactive. */
export const QC_TASK_WORKFLOWS_STALE_MS = 1000 * 60 * 5;

/** TanStack Query: batches list uses the same TTL as workflows. */
export const QC_TASK_BATCHES_STALE_MS = 1000 * 60 * 5;

/** TanStack Query: assignment rows refresh a bit more often (2 minutes). */
export const QC_TASK_ASSIGNMENTS_STALE_MS = 1000 * 60 * 2;

/**
 * Default page-size picker values if `VITE_QC_TASK_PAGE_SIZES` is missing or invalid.
 * @type {number[]}
 */
export const QC_TASK_DEFAULT_PAGE_SIZE_OPTIONS = [
  10, 20, 60, 100, 300, 500, 1000, 5000,
];

/** Default rows per page when env default is unset. */
export const QC_TASK_FALLBACK_DEFAULT_PAGE_SIZE = 20;

/**
 * Workflows hidden from the My QC Task page — annotation/segmentation work
 * happens on its own dedicated page (`/annotation-segmentation`), not here.
 */
export const QC_TASK_EXCLUDED_WORKFLOW_IDS = [
  'QC-WF-ANNOTATION-01',
  'QC-WF-SEGMENTATION-01',
];
